import React, { useState, useEffect } from 'react';
import AdminOverlay from './AdminOverlay';
import PayPalOverlay from './PayPalOverlay';

export default function TopBar({
  email,
  tier,
  credits,
  insufficientCredits,
  handleClearCache,
  handleToggleMaintenance,
  maintenance,
  setCredits,
}) {
  const [showOverlay, setShowOverlay] = useState(false);
  const [showPayPal, setShowPayPal] = useState(false);

  const tierAsset = {
    'all-access': 'asset1.png',
    'patreon-access': 'asset2.png',
    free: 'asset5.png',
    admin: 'asset4.png',
    support: 'asset3.png'
  };

  const safeTier = tier || 'guest';
  const asset = tierAsset[safeTier];
  const username = email?.split('@')[0] ?? '';

  useEffect(() => {
  const style = document.createElement('style');
  style.innerHTML = `
      @keyframes flashColors {
        0% { color: red; }
        25% { color: orange; }
        50% { color: yellow; }
        75% { color: limegreen; }
        100% { color: red; }
      }

      /* --- BUTTON FONT SIZE RULES --- */

      /* Mobile (default) */
      .admin-btn {
        font-size: 1.8vmax !important;
      }

      .buy-credits-btn {
        font-size: 1.8vmax !important;
      }

      /* Desktop ≥ 768px */
      @media (min-width: 768px) {
        .admin-btn {
          font-size: 1.3vmax !important;
        }

        .buy-credits-btn {
          font-size: 1.3vmax !important;
        }

        .wabu-svg {
          height: 130% !important;
        }
      }
    `;
  document.head.appendChild(style);
  return () => {
    document.head.removeChild(style);
  };
}, []);


  return (
    <div
      style={{
        width: '100%',
        height: '15vmax',
        minHeight: '120px',
        backgroundColor: '#bdbdbdff',
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        padding: 0,
        position: 'relative',
        boxSizing: 'border-box',
        border: '0px solid red',
      }}
    >
      {/* LEFT: Wabu Section */}
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          paddingLeft: '1vmin',
          paddingRight: '1vmin',
          border: '0px dashed lime',
          boxSizing: 'border-box',
          flexShrink: 0,
        }}
      >
        <object
          type="image/svg+xml"
          data="/Wabu.svg"
          aria-label="Wabu"
          className="wabu-svg"
          style={{
            height: '57%',           // ✅ base: mobile & fallback
            width: 'auto',
            display: 'block',
            pointerEvents: 'none',
            border: '0px solid cyan',
            boxSizing: 'border-box',
          }}
        />
      </div>

      {/* RIGHT: User Info block (icon + text) */}
      <div
        style={{
          flexGrow: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            height: '100%',
            display: 'flex',
            gap: '0.5vmin',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            border: '0px solid orange',
            boxSizing: 'border-box',
            paddingBottom: '0.5vmin',
          }}
        >
          {/* TEXT ON LEFT */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between', // ⬅ top + bottom separation
              alignItems: 'center',             // ⬅ center horizontally
              textAlign: 'center',
              height: '100%',                   // ⬅ needed for vertical space
              paddingBottom: '1.5vmin',
              paddingTop: '0.5vmin',
              boxSizing: 'border-box',
            }}
          >
          {email && (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  paddingTop: '5vmin',   // ← added padding to move username/credits downward
                  boxSizing: 'border-box',
                }}
              >
                <p style={{ fontWeight: 'bold', fontSize: '2.5vmin', margin: 1 }}>
                  {username}
                </p>
                <p style={{ fontSize: '2.5vmin', margin: 1 }}>
                  Credits: {credits}
                </p>

                {insufficientCredits && (
                  <p
                    style={{
                      fontSize: '1vmax',
                      fontWeight: 'bold',
                      marginTop: '0.5vh',
                      animation: 'flashColors 1.2s infinite',
                    }}
                  >
                    Insufficient Credits!
                  </p>
                )}
              </div>

              <button
                onClick={() => setShowPayPal(true)}
                className="buy-credits-btn"
                style={{
                  padding: '1vmin',
                  borderRadius: '6px',
                  backgroundColor: '#ffc439',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  color: 'black',
                }}
              >
                Buy Credits
              </button>
            </>
          )}

          </div>

          {/* ICON ON RIGHT */}
          <img
            src={`/${asset}`}
            alt="User Tier Icon"
            style={{
              height: '14vmax',
              width: 'auto',
              display: 'block',
            }}
          />
        </div>
      </div>

    {/* ADMIN BUTTON – top-left */}
    {tier === 'admin' && (
      <div
        style={{
          position: 'absolute',
          top: '1vmin',      // ⬅ moved from bottom to top
          left: '1vmin',
          zIndex: 5,
        }}
      >
      <button
        onClick={() => setShowOverlay(true)}
        className="admin-btn"
        style={{
          padding: '1vmin',
          backgroundColor: '#1d4ed8',
          color: 'white',
          fontWeight: 'bold',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
        }}
      >

          Admin Dashboard
        </button>
      </div>
    )}


      {/* Overlays */}
      {showOverlay && (
      <AdminOverlay
        email={email}
        onClose={() => setShowOverlay(false)}
        onClearCache={handleClearCache}
        onToggleMaintenance={handleToggleMaintenance}
        maintenance={maintenance}
      />

      )}

      {showPayPal && (
        <PayPalOverlay
          email={email}
          onClose={() => setShowPayPal(false)}
          setCredits={setCredits}
        />
      )}
    </div>
  );
}
